/**
 * 🔴 **THE DEVELOPMENT PASSWORD, IN ONE PLACE, BECAUSE FOUR PLACES DISAGREED.**
 *
 * On 2026-09-13 this value existed as four private copies and they had drifted apart:
 * `tools/seed-dev-passwords.mts` seeded `"pinksy-dev-password"` while
 * `apps/shell/src/auth/devPeople.ts` typed `"password"` into the persona picker, so the documented
 * one-command dev loop signed nobody in. `tools/seed-personas.ts` and
 * `tools/db-proofs/seed-devin.mts` held a third and fourth copy of `"password"`.
 *
 * Two things then made the drift fatal rather than annoying. `hashPassword()` now enforces the
 * 12-character policy itself and THROWS, so every copy still holding `"password"` broke its tool at
 * runtime. And because a seeder and a sign-in form are on opposite sides of the repo, nothing
 * compared them — the value is only ever correct by coincidence.
 *
 * So it lives here: `@pinksy/contracts` is source-consumed, has no DOM dependency, and both
 * `tools/` and `apps/shell` can import it. One constant, one place, and a mismatch becomes a
 * compile error rather than a silent failure to sign in.
 *
 * 🔴 **This is a DEVELOPMENT value and it must never reach a deployed environment.** The seeders
 * that use it refuse a non-local database (`tools/seed-dev-passwords.mts`, `tools/import-*.ts`), and
 * the persona picker that types it is behind `DevAuthEnabled` plus an environment-type check
 * (`services/auth/dev-people.ts`). It is a convenience for a laptop, not a default.
 */
export const DEV_PASSWORD = "pinksy-dev-password";
